Array.prototype.sortBy = function(p, isDescending = true) {
  try{
    let r = this.slice(0).sort(function(a,b) {
      return (a[p].toLowerCase() > b[p].toLowerCase()) ? 1 : (a[p].toLowerCase() < b[p].toLowerCase()) ? -1 : 0;
    });
    if(isDescending){
      return r;
    }
    else{
      return r.reverse();
    }
  }
  catch(err){
    let r = this.slice(0).sort(function(a, b){return a[p]-b[p]});
    if(isDescending){
      return r;
    }
    else{
      return r.reverse();
    }
  }
}

Array.prototype.sortByNumeric = function(p) {
  return this.slice(0).sort(function(a, b){return a[p]-b[p]});
}
